import axiosInstance from '@/shared/api/axios';
import type {
  ApiParcelsClaimPostBody,
  ApiParcelsConfirmShippingPostBody,
  ApiParcelsConfirmShippingPostResponse,
  ApiParcelsDetailGetResponse,
  ApiParcelsGetItem,
  ApiParcelsMyDebts,
  ApiParcelsMyGetResponse,
  ApiParcelsPostBody,
  ApiParcelsPutBody,
} from '@/shared/types/api/parcels';

export const apiParcelsMyGet = async (cargoId?: string): Promise<ApiParcelsMyGetResponse> => {
  const { data } = await axiosInstance.get<ApiParcelsMyGetResponse>('/parcels/my', {
    params: cargoId ? { cargo_id: cargoId } : undefined,
  });
  return data;
};

export const apiParcelsDetailGet = async (id: string): Promise<ApiParcelsDetailGetResponse> => {
  const { data } = await axiosInstance.get<ApiParcelsDetailGetResponse>(`/parcels/${id}`);
  return data;
};

export const apiParcelsPost = async (body: ApiParcelsPostBody): Promise<ApiParcelsGetItem> => {
  const { data } = await axiosInstance.post<ApiParcelsGetItem>('/parcels/my', body);
  return data;
};

export const apiParcelsPut = async (
  id: string,
  body: ApiParcelsPutBody,
): Promise<ApiParcelsGetItem> => {
  const { data } = await axiosInstance.put<ApiParcelsGetItem>(`/parcels/${id}`, body);
  return data;
};

export const apiParcelsDelete = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/parcels/${id}`);
};

export const apiParcelsClaimPost = async (
  body: ApiParcelsClaimPostBody,
): Promise<ApiParcelsGetItem> => {
  const { data } = await axiosInstance.post<ApiParcelsGetItem>('/parcels/claim', body);
  return data;
};

export const apiParcelsConfirmShippingPost = async (
  body: ApiParcelsConfirmShippingPostBody,
): Promise<ApiParcelsConfirmShippingPostResponse> => {
  const { data } = await axiosInstance.post<ApiParcelsConfirmShippingPostResponse>(
    '/parcels/confirm-shipping',
    body,
  );
  return data;
};

export const apiParcelsAvailableForPhotoVideo = async (
  type: 'PHOTO' | 'VIDEO' | 'PROVERKA',
): Promise<ApiParcelsMyGetResponse> => {
  const { data } = await axiosInstance.get<ApiParcelsMyGetResponse>(
    `/parcels/available-for-photo-video?type=${type}`,
  );
  return data;
};

export const apiParcelsAvailableForSplit = async (): Promise<ApiParcelsMyGetResponse> => {
  const { data } = await axiosInstance.get<ApiParcelsMyGetResponse>('/parcels/available-for-split');
  return data;
};

export const apiParcelsMyDebtsGet = async (): Promise<ApiParcelsMyDebts> => {
  const { data } = await axiosInstance.get<ApiParcelsMyDebts>('/parcels/my/debts');
  return data;
};
